var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyGreenBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 7.72811 17.3551 6.60695 16.3741 5.9455C16.5999 4.7846 16.2631 3.53596 15.364 2.63603C14.4648 1.73686 13.2161 1.40013 12.0545 1.62586C11.3931 0.644946 10.2719 0 9 0C7.72811 0 6.60695 0.644946 5.9455 1.62586C4.7846 1.40013 3.53521 1.73686 2.63603 2.63603C1.73686 3.53521 1.40013 4.78385 1.62586 5.9455C0.644946 6.60695 0 7.72811 0 9C0 10.2719 0.644946 11.3931 1.62586 12.0545C1.40013 13.2154 1.73686 14.4648 2.63603 15.364C3.53521 16.2631 4.78385 16.5999 5.9455 16.3741C6.60695 17.3551 7.72811 18 9 18C10.2719 18 11.3931 17.3551 12.0545 16.3741C13.2154 16.5999 14.4648 16.2631 15.364 15.364C16.2631 14.4648 16.5999 13.2161 16.3741 12.0545C17.3551 11.3931 18 10.2719 18 9ZM8.93251 11.564C8.64228 11.8543 8.26056 11.999 7.87734 11.999C7.49412 11.999 7.10866 11.8528 6.81543 11.5603L4.72911 9.53846L5.77377 8.4608L7.86834 10.4909L12.2247 6.21548L13.2776 7.28414L8.93251 11.564Z",
    fill: "#04B20B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyGreenBadge);
export default __webpack_public_path__ + "static/media/verifyGreenBadge.e4970c44bc626b1625d442f09b5e87aa.svg";
export { ForwardRef as ReactComponent };